import {Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import {Item} from '../../../models/lookups/item';
import {ItemService} from '../../../services/lookups/item.service';

import {Query} from '../../../models/query/query';
import {Criterion} from '../../../models/query/criterion';
import {OrnService} from 'app/services/nabavke/orn.service';
import {Orn} from 'app/models/lookups/orn';

@Component({
  selector: 'bms-auto-complete-cmb-multiple',
  templateUrl: './auto-complete-cmb-multiple.component.html',
  styleUrls: ['./auto-complete-cmb-multiple.component.scss']
})
export class AutoCompleteCmbMultipleComponent implements OnInit {
    @Input()
    item: any;
    results: any[];
    @Input()
    dataType: String;

    fieldName: string = "itemName";

    @Output()
    itemChosen = new EventEmitter<any>();

    protected itemService: ItemService;
    protected ornService: OrnService;

    constructor(injector: Injector) {
        this.itemService = injector.get(ItemService);
        this.ornService = injector.get(OrnService);
    }

    ngOnInit() {
        if (this.dataType == "Item") {
            this.fieldName = "itemName";
        }else if (this.dataType == "ItemsForOutPlusServices") {
            this.fieldName = "itemName";
        }else if (this.dataType == "Orn") {
            this.fieldName = "description";
        }
    }

    search(event){
        if (this.dataType == "Item") {
            let query = new Query();
            query.and().or(Criterion.like(Item.TABLENAME, Item.CODE, '%' + event.query + '%'))
            .or(Criterion.like(Item.TABLENAME, Item.ITEM_NAME, '%' + event.query + '%'));

            this.itemService.list(query).subscribe(
                res => this.results = res
            );
        } else if (this.dataType == "ItemsForOutPlusServices") {
            let query = new Query();
            query.and().or(Criterion.like(Item.TABLENAME, Item.CODE, '%' + event.query + '%'))
            .or(Criterion.like(Item.TABLENAME, Item.ITEM_NAME, '%' + event.query + '%'));

            this.itemService.listForOutPlusServices(query).subscribe(
                res => this.results = res
            );
        } else if (this.dataType == "Orn") {
            let query = new Query();
            query.and().or(Criterion.like(Orn.TABLENAME, Orn.CODE, '%' + event.query + '%'))
            .or(Criterion.like(Orn.TABLENAME, Orn.DESCRIPTION, '%' + event.query + '%'));

            this.ornService.list(query).subscribe(
                res => this.results = res
            );
        }

    }

    eventSelected(){
        this.itemChosen.emit(this.item);
    }

}
